module.exports = __webpack_public_path__ + "images/common_icon_down.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/common_icon_down.png
// module id = 847
// module chunks = 125